var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.code)?_c('div',{staticClass:"flag",class:_vm.code}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }